import { isDateInPast, getIsoDateStringAsDate, dateDescriptionStringAddExtraDescriptor } from "./date-time";

export var getSurveyOverdueStatus = (date) => {
    if (date && (isDateInPast(getIsoDateStringAsDate(date)))) {
        return true;
    }
    else {
        return false;
    }
}

export function getSurveyScheduleTooltip(inmate) {
    let tooltipContent = [];

    if (inmate.surveyScheduleUrn == null) {
        return null;
    }

    tooltipContent.push((inmate.surveyScheduleNumberCompleted + " of " + inmate.surveyScheduleTotal + " survey") + (inmate.surveyScheduleTotal > 1 ? "s" : "") + " completed");

    if (inmate.surveyScheduleLatestSurveyDateDescription) {
        tooltipContent.push("Last completed " + dateDescriptionStringAddExtraDescriptor(inmate.surveyScheduleLatestSurveyDateDescription, true));
    }

    tooltipContent.push((getSurveyOverdueStatus(inmate.surveyScheduleNextSurveyDate) ? 'Overdue ' + (dateDescriptionStringAddExtraDescriptor(inmate.surveyScheduleNextSurveyDateDescription, false) === 'Yesterday' ? 'since ' : 'by ') : 'Next due ') + dateDescriptionStringAddExtraDescriptor(inmate.surveyScheduleNextSurveyDateDescription, false).toLowerCase());

    if (inmate.surveyScheduleNextSurveyDateDescription) {
        if ((inmate.surveyScheduleTotal > 1) && (inmate.surveyScheduleFrequency == 1)) {
            tooltipContent.push("Recurring every day");
        }
        else if ((inmate.surveyScheduleTotal > 1) && (inmate.surveyScheduleFrequency > 1) ) {
            tooltipContent.push("Recurring every " + inmate.surveyScheduleFrequency + " days");
        }
    }

    return {tooltipLines: tooltipContent};
}

export function getSurveyToastProperties(scheduleType, scheduleTotal, name, urn) {
    return {
        title: (scheduleType === 'add') ? "Survey Schedule Added" : (scheduleType === 'update' ? 'Survey Schedule Updated' : 'Survey Schedule Cancelled'),
        content: generateSurveyToastContent(scheduleType, scheduleTotal),
        navigateLabel: name,
        navigateString: `/history/${urn}`,
        isOpen: true
    };
}

function generateSurveyToastContent(scheduleType, scheduleTotal) {
    if (scheduleType === 'add') {
        if (scheduleTotal === 1) return scheduleTotal + " survey added for ";
        else return "Block of " + scheduleTotal + " surveys added for ";   
    } else if (scheduleType === 'cancel') {
        if (scheduleTotal === 1) return scheduleTotal + " survey cancelled for ";
        else return "Block of " + scheduleTotal + " surveys cancelled for ";
    } else if (scheduleType === 'update') {
        if (scheduleTotal === 1) return scheduleTotal + " survey updated for ";
        else return "Block of " + scheduleTotal + " surveys updated for ";
    }
}